class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");
        this.uid = this.iframe.dataset.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }

        window.addEventListener("message", this.receiveMessage.bind(this));
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }

    receiveMessage(e) {
        if (e.data.progress) {
            const pageTitle = e.data.progress;

            if (pageTitle === "Login") {
                $("h1").text("Login");

                
            } else if (pageTitle === "ForgotPassword") {
                $("h1").text("Forgot password");
            } else if (pageTitle === "NewAccount") {
                $("h1").text("Register");
            } else if (pageTitle === "MyAccount") {
                $("h1").text("My account");
                $(".custom-message").attr("aria-hidden", "true");
            }

            $("h1").css({ visibility: "visible" });
        }

        if (typeof e.data === "string" && e.data.startsWith("resize:")) {
            const newHeight = Number(e.data.slice(7));
            this.iframe.style.height = newHeight + "px";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
